import { render, staticRenderFns } from "./TopNavV2.vue?vue&type=template&id=0968b3e2&"
import script from "./TopNavV2.vue?vue&type=script&lang=js&"
export * from "./TopNavV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports